import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    mailServer: {
      tableData: [],
      totalMailServer: 0
    },
    queryMailServer: {
      page: 0,
      size: 20,
      sort: 'id,DESC'
    },
    listSelectedFiltersMailServer: []
  }
  return session
}
function initLocal () {
  const local = {
    isShowMailServerMailFrom: true,
    isShowMailServerHost: true,
    isShowMailServerUser: true,
    isShowMailServerAuth: false,
    isShowMailServerIdClient: false,
    isShowMailServerIdTenant: false,
    isShowMailServerSaveToSentItems: false,
    isShowMailServerValidityDateTo: false,
    isShowMailServerPort: false,
    isShowMailServerProtocol: false
  }
  return local
}
function setByUserLocalMailServer () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer) {
    const local = {
      isShowMailServerMailFrom: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerMailFrom,
      isShowMailServerHost: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerHost,
      isShowMailServerUser: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerUser,
      isShowMailServerAuth: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerAuth,
      isShowMailServerIdClient: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerIdClient,
      isShowMailServerIdTenant: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerIdTenant,
      isShowMailServerSaveToSentItems: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerSaveToSentItems,
      isShowMailServerPort: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerPort,
      isShowMailServerProtocol: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerProtocol,
      isShowMailServerValidityDateTo: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).mailServer.isShowMailServerValidityDateTo
    }
    return local
  } else {
    return initLocal()
  }
}

const state = {
  userConfigLocalStorage: '',
  local: {
    isShowMailServerMailFrom: true,
    isShowMailServerHost: true,
    isShowMailServerUser: true,
    isShowMailServerAuth: false,
    isShowMailServerIdClient: false,
    isShowMailServerIdTenant: false,
    isShowMailServerSaveToSentItems: false,
    isShowMailServerValidityDateTo: false,
    isShowMailServerPort: false,
    isShowMailServerProtocol: false
  },
  session: initSession()
}
const getters = {
  mailServer: state => {
    return state.session.mailServer
  },
  queryMailServer: state => {
    return state.session.queryMailServer
  },
  listSelectedFiltersMailServer: state => {
    return state.session.listSelectedFiltersMailServer
  },
  isShowMailServerMailFrom: state => {
    return state.local.isShowMailServerMailFrom
  },
  isShowMailServerHost: state => {
    return state.local.isShowMailServerHost
  },
  isShowMailServerUser: state => {
    return state.local.isShowMailServerUser
  },
  isShowMailServerAuth: state => {
    return state.local.isShowMailServerAuth
  },
  isShowMailServerIdClient: state => {
    return state.local.isShowMailServerIdClient
  },
  isShowMailServerIdTenant: state => {
    return state.local.isShowMailServerIdTenant
  },
  isShowMailServerSaveToSentItems: state => {
    return state.local.isShowMailServerSaveToSentItems
  },
  isShowMailServerPort: state => {
    return state.local.isShowMailServerPort
  },
  isShowMailServerProtocol: state => {
    return state.local.isShowMailServerProtocol
  },
  isShowMailServerValidityDateTo: state => {
    return state.local.isShowMailServerValidityDateTo
  }
}

const actions = {

  // Crear key Usuario
  setUserNameMailServer ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalMailServer()
    }
  },

  isNewVersionMailServerLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.mailServer)
  },
  /**
     * Servicio para traer los servidores de correo.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getMailServer ({
    commit, rootState
  }, data) {
    try {
      data.query.urlHost = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlHost = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/mailServer',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      commit('MAIL_SERVER_STATE', {
        tableData: response.data.content,
        totalMailServer: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Modifica un servidor */
  async modifyMailServer ({ commit, rootState }, data) {
    console.log('modifyMailServer::data.saveToSentItems ', data.saveToSentItems)
    var saveToSentItems = data.saveToSentItems
    console.log('saveToSentItems ', saveToSentItems)
    try {
      const response = await axios({
        method: 'PUT',
        url: '/mailServer/' + data.mailServerId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          host: data.host,
          user: data.user,
          password: data.password,
          mailFrom: data.mailFrom,
          auth: data.auth,
          protocol: data.protocol,
          port: data.port,
          idClient: data.idClient,
          idTenant: data.idTenant,
          clientSecret: data.clientSecret,
          saveToSentItems: saveToSentItems,
          validityDateTo: data.validityDateTo
        }
      })

      console.log('RESPONSE modifyMailServer:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Activa/desactiva un servidor */
  async activeMailServer ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/mailServer/' + request.mailServerId + '/enable',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          enable: request.enable
        }
      })
      console.log('RESPONSE modifyMailServer:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async testMailServer ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/mailServer/' + data.mailServerId + '/test',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          host: data.host,
          user: data.user,
          password: data.password,
          mailFrom: data.mailFrom,
          auth: data.auth,
          protocol: data.protocol,
          port: data.port,
          idClient: data.idClient,
          idTenant: data.idTenant,
          clientSecret: data.clientSecret,
          saveToSentItems: data.saveToSentItems,
          validityDateTo: data.validityDateTo
        }
      })

      console.log('RESPONSE testMailServer:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para eliminar un servidor
   * @param {*} roleId
   */
  async deleteMailServer ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/mailServer/' + params.mailServerId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de un servidor
  async getMailServerDetail ({ commit, rootState }, mailServerId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/mailServer/' + mailServerId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  mailServerState: ({
    commit
  }, payload) => {
    commit('MAIL_SERVER_STATE', payload)
  },
  queryMailServerState: ({
    commit
  }, payload) => {
    commit('QUERY_MAIL_SERVER_STATE', payload)
  },
  listSelectedFiltersMailServerState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_MAIL_SERVER_STATE', payload)
  },
  isShowMailServerMailFromAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_MAILFROM', payload)
  },
  isShowMailServerHostAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_HOST', payload)
  },
  isShowMailServerUserAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_USER', payload)
  },
  isShowMailServerAuthAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_AUTH', payload)
  },
  isShowMailServerIdClientAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_IDCLIENT', payload)
  },
  isShowMailServerIdTenantAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_IDTENANT', payload)
  },
  isShowMailServerValidityDateToAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_VALIDITYDATETO', payload)
  },
  isShowMailServerSaveToSentItemsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_SAVETOSENTITEMS', payload)
  },
  isShowMailServerPortAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_PORT', payload)
  },
  isShowMailServerProtocolAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_PROTOCOL', payload)
  }

}

const mutations = {
  resetSessionMailServer (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  'MAIL_SERVER_STATE' (state, payload) {
    state.session.mailServer = payload
  },
  'QUERY_MAIL_SERVER_STATE' (state, payload) {
    state.session.queryMailServer = payload
  },
  'LIST_SELECTED_FILTERS_MAIL_SERVER_STATE' (state, payload) {
    state.session.listSelectedFiltersMailServer = payload
  },
  'IS_SHOW_MAIL_SERVER_MAILFROM' (state, payload) {
    state.local.isShowMailServerMailFrom = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerMailFrom = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_HOST' (state, payload) {
    state.local.isShowMailServerHost = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerHost = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_USER' (state, payload) {
    state.local.isShowMailServerUser = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerUser = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_AUTH' (state, payload) {
    state.local.isShowMailServerAuth = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerAuth = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_IDCLIENT' (state, payload) {
    state.local.isShowMailServerIdClient = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerIdClient = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_IDTENANT' (state, payload) {
    state.local.isShowMailServerIdTenant = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerIdTenant = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_VALIDITYDATETO' (state, payload) {
    state.local.isShowMailServerValidityDateTo = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerValidityDateTo = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_SAVETOSENTITEMS' (state, payload) {
    state.local.isShowMailServerSaveToSentItems = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerSaveToSentItems = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_PORT' (state, payload) {
    state.local.isShowMailServerPort = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerPort = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_PROTOCOL' (state, payload) {
    state.local.isShowMailServerProtocol = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.mailServer.isShowMailServerProtocol = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
